/*
	Browser detection from ItsTheS until we have a better solution
*/
import { mapActions } from 'vuex'
import { detect } from 'detect-browser'
import MobileDetect from 'mobile-detect'

import {
	VUEX_GLOBAL_SET_BROWSER_STATE,
	VUEX_GLOBAL_SET_MOBILE_STATE
} from '@/store/constants/mobile'


const md = new MobileDetect(window.navigator.userAgent)

const browser = detect()

const BrowserDetection = {
	created() {
		let browserObj = browser
		browserObj.supports = {}
		browserObj.supports.grid = this.featureSupportsGrid(browserObj)
		browserObj.supported = this.supportedBrowser(browserObj)

		this.global_setBrowserState(browserObj)
		this.setBodyBrowserClass()
		this.blockedBrowser()

		this.global_setMobileState(this.getMobile())
	},
	methods: {
		...mapActions({
			global_setBrowserState: VUEX_GLOBAL_SET_BROWSER_STATE,
			global_setMobileState : VUEX_GLOBAL_SET_MOBILE_STATE
		}),
		getMobile:() => !md.mobile() ? false : true,
		getBrowserName:() => browser.name,
		getBrowserVersion:() => browser.version,
		supportedBrowser: () => {
			let name = browser.name
			let version = parseInt(browser.version)

			switch(name)
			{
				case 'chrome' :
					return (version >= 64) ? true : false
				case 'firefox' :
					return (version >= 57) ? true : false
				case 'safari' :
					return (version >= 9) ? true : false
				case 'edge' :
					return (version >= 15) ? true : false
				case 'ie' :
					return (version >= 11) ? true : false
				default :
					return true
			}
		},
		blockedBrowser: () => {
			let name = browser.name
			let version = parseInt(browser.version)
			let isBlocked

			switch(name)
			{
				case 'safari' :
					isBlocked = (version < 9) ? true : undefined
					break
				case 'ie' :
					isBlocked = (version < 11) ? true : undefined
					break
				default :
					isBlocked = undefined
					break
			}

			if(isBlocked) document.body.classList.add('blocked')
		},
		featureSupportsGrid: (browser) => {
			let name = browser.name
			let version = parseInt(browser.version)

			switch(name)
			{
				case 'chrome' :
					return (version >= 64) ? true : false
				case 'firefox' :
					return (version >= 59) ? true : false
				case 'safari' :
					return (version >= 11) ? true : false
				case 'edge' :
					return (version >= 15) ? true : false
				case 'ie' :
					return (version >= 11) ? true : false
				default :
					return true
			}
		},
		setBodyBrowserClass() {
			let name = browser.name
			let version = parseInt(browser.version)
			let browserClass

			switch(name)
			{
				case 'chrome' :
					break
				case 'firefox' :
					break
				case 'safari' :
					// Will add versions later
					//browserClass = (version == 10) ? "safari-10" : undefined
					browserClass = "safari"
					break
				case 'edge' :
					//browserClass = (version == 15) ? "edge-15" : undefined
					browserClass = "edge"
					break
				case 'ie' :
					//browserClass = (version >= 11) ? "ie-11" : undefined
					browserClass = "ie"
					break
				default :
					break
			}

			if(browserClass) document.body.classList.add(browserClass)
		}
	}
}

export default BrowserDetection
